import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '../../../Typography';

import SidebarEditFormFieldRecordRef from '../../Form/FieldRecordRef';
import SidebarEditFormFieldText from '../../Form/FieldText';
import SidebarEditFormFieldSelect from '../../Form/FieldSelect';
import SidebarEditFormFieldMultiAttachment from '../../Form/FieldMultiAttachment';
import { FIELD_ELEMENT_TYPE_MAP } from '../../../../constants/field';

import { ISpace } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';
import { IRootState } from '../../../../modules/stores';
import { ColumnType } from '../../../../modules/core/graphql/types';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  space: ISpace<ElementTypes>;
  isNodeVisible?: boolean;
}

class EditFormFieldLookup extends React.PureComponent<IProps & IConnectProps> {
  public render() {
    const { lookupFieldId, lookupFieldType, space, isNodeVisible } = this.props;
    if (!lookupFieldId || !lookupFieldType)
      return (
        <Typography style={{ color: 'white', 'white-space': 'normal' }}>
          This element can not be configured because there is no data.
        </Typography>
      );
    switch (FIELD_ELEMENT_TYPE_MAP[lookupFieldType as ColumnType]) {
      case ElementTypes.FieldText:
      case ElementTypes.FieldLongText:
      case ElementTypes.FieldNumber:
      case ElementTypes.FieldPhone:
      case ElementTypes.FieldCollaborator:
      case ElementTypes.FieldEmail:
      case ElementTypes.FieldDateTime:
      case ElementTypes.FieldCurrency:
      case ElementTypes.FieldAutoNumber:
      case ElementTypes.FieldFormula:
      case ElementTypes.FieldRollup:
        return <SidebarEditFormFieldText space={space} />;
      case ElementTypes.FieldStatus:
      case ElementTypes.FieldSelect:
      case ElementTypes.FieldMultiSelect:
      case ElementTypes.FieldRating:
      case ElementTypes.FieldCheckbox:
        return <SidebarEditFormFieldSelect space={space} />;
      case ElementTypes.FieldMultiAttachment:
        return <SidebarEditFormFieldMultiAttachment space={space} />;
      case ElementTypes.FieldRecordRef:
      case ElementTypes.FieldSubtable:
        return (
          <SidebarEditFormFieldRecordRef
            space={space}
            lookupFieldId={lookupFieldId}
            isNodeVisible={isNodeVisible}
          />
        );
      default:
        return null;
    }
  }
}

const mapState = ({ core }: IRootState, { space }: IProps) => {
  // const lookupFieldId = get(core, `fieldById.${space.fieldId}.typeOptions.foreignLookupColumnId`);
  const lookupFieldId = space.fieldId;
  const lookupFieldType = get(core, `fieldById.${space.fieldId}.typeOptions.lookupColumnType`);

  return {
    lookupFieldType,
    lookupFieldId,
  };
};

export default connect(mapState)(EditFormFieldLookup);
